import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { UnitDetailView } from 'components';
import {
  fetchUnitDetails, cleanUnitDetails, setCurrentDevice, fetchAlertsByLocation, changeValveState, openConfirmationDialog,
  setCurrentAlert, clearAlert, fetchConsumptionData, cleanConsumptionData, fetchAreaTemperatureByLocation,
  startPresence, stopPresence, startTelemetryPolling, stopTelemetryPolling, openTextConfirmationModal,
  openRenameDeviceModal, deleteDevice, updateDevice, runHealthTest, clearCriticalAlertAndSubmitFeedback
} from 'actions';
import { Unit, Device, RealTimeDeviceData, Alert, ValveState, ConsumptionPeriod, Location, FormattedConsumptionData, User } from 'model';
import {
  selectCurrentUnit, selectCurrentDevice, selectHasMultipleDevices, selectCurrentRealtimeData,
  selectUpdatedTelemetryText, selectRealtimeMap, selectIsLoadingAlert, selectAlertList, selectIsLoadingUnit,
  selectCurrentAlert, selectIsSubmittingAlertAction, selectHasErrorMessage, selectPendingAlertsForCurrentDevice, selectLoggedUser
} from 'selectors';
import { subscribeDeviceData, unSubscribeDeviceData } from 'actions';
import { selectIsSubmittingThresholds, selectIsSubmittingAlertSettings } from 'selectors/Settings';
import { selectConsumptionPeriod, selectFormattedChartData } from 'selectors/Consumption';
import { selectIsSubmittingDeveloperMenu } from 'selectors/DeveloperMenu';

type SelectedValues = {
  currentUnit?: Unit,
  currentDevice?: Device,
  hasMultipleDevices: boolean,
  currentDeviceRealtime?: RealTimeDeviceData,
  loggedUser?: User,
  updatedTelemetryText: string,
  realtimeMap: { [macAddress: string]: RealTimeDeviceData },
  isLoadingAlert: boolean,
  alertList: Alert[],
  isLoadingUnit: boolean,
  currentAlert: Alert | null,
  isSubmittingAction: boolean,
  hasError: boolean,
  isSubmittingThresholdSettings: boolean,
  isSubmittingAlertSettings: boolean,
  consumptionPeriod: ConsumptionPeriod,
  consumptionData: FormattedConsumptionData,
  pendingAlertsForCurrentDevice: Alert[],
  isSubmittingDeveloperMenu: boolean,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  currentUnit: selectCurrentUnit(),
  currentDevice: selectCurrentDevice(),
  hasMultipleDevices: selectHasMultipleDevices(),
  currentDeviceRealtime: selectCurrentRealtimeData(),
  loggedUser: selectLoggedUser(),
  updatedTelemetryText: selectUpdatedTelemetryText(),
  realtimeMap: selectRealtimeMap(),
  isLoadingAlert: selectIsLoadingAlert(),
  alertList: selectAlertList(),
  isLoadingUnit: selectIsLoadingUnit(),
  currentAlert: selectCurrentAlert(),
  isSubmittingAction: selectIsSubmittingAlertAction(),
  hasError: selectHasErrorMessage(),
  isSubmittingThresholdSettings: selectIsSubmittingThresholds(),
  isSubmittingAlertSettings: selectIsSubmittingAlertSettings(),
  consumptionPeriod: selectConsumptionPeriod(),
  consumptionData: selectFormattedChartData(),
  pendingAlertsForCurrentDevice: selectPendingAlertsForCurrentDevice(),  
  isSubmittingDeveloperMenu: selectIsSubmittingDeveloperMenu(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchUnitDetails: (unitId: string) => dispatch(fetchUnitDetails(unitId)),
  subscribeDeviceData: (macAddresses: string[]) => dispatch(subscribeDeviceData(macAddresses)),
  unSubscribeDeviceData: () => dispatch(unSubscribeDeviceData()),
  cleanUnitDetails: () => dispatch(cleanUnitDetails()),
  setCurrentDevice: (macAddress: string) => dispatch(setCurrentDevice(macAddress)),
  fetchAlertsByLocation: (locationId: string) => dispatch(fetchAlertsByLocation(locationId)),
  changeValveState: (deviceId: string, target: ValveState) => dispatch(changeValveState(deviceId, target)),
  deleteDevice: (deviceId: string) => dispatch(deleteDevice(deviceId)),
  updateDevice: (deviceId: string, device: Partial<Device>) => dispatch(updateDevice(deviceId, device)),
  openConfirmationDialog: (metadata?: { [key: string]: any }) => dispatch(openConfirmationDialog(metadata)),
  openTextConfirmationModal: (metadata?: { [key: string]: any }) => dispatch(openTextConfirmationModal(metadata)),
  openRenameDeviceModal: (metadata?: { [key: string]: any }) => dispatch(openRenameDeviceModal(metadata)),
  setCurrentAlert: (currentAlert: Alert | null) => dispatch(setCurrentAlert(currentAlert)),
  resolveAlert: (alert: Alert, snoozeSeconds: number = 0) => dispatch(clearAlert(alert, snoozeSeconds)),
  feedbackCriticalAlert: (alert:Alert, feedbackType: string) => dispatch(clearCriticalAlertAndSubmitFeedback(alert, feedbackType)),
  fetchConsumptionData: (period: ConsumptionPeriod, location: Location) => dispatch(fetchConsumptionData(period, location)),
  cleanConsumptionData: () => dispatch(cleanConsumptionData()),
  fetchAreaTemperatureByLocation: (macAddress: string, timezone: string) => dispatch(fetchAreaTemperatureByLocation(macAddress, timezone)),
  startPresence: (locationId: string) => dispatch(startPresence([locationId])),
  stopPresence: () => dispatch(stopPresence()),
  startTelemetryPolling: (unitId: string) => dispatch(startTelemetryPolling(unitId)),
  stopTelemetryPolling: () => dispatch(stopTelemetryPolling()),
  runHealthTest: (deviceId: string) => dispatch(runHealthTest(deviceId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnitDetailView);
